import React from 'react';
import PropTypes from 'prop-types';


const ImageModal = ({
  t,
  upload,
  active,
  mainScr,
  toggleModal,
  downloadLink,
  onImageError,
}) => (
  <React.Fragment>
    <div className={`modal boxs ${active ? 'active' : ''}`}>
      <div className="modal-dialog">
        <div className="boxs docpreview boxs chosefl">
          <div className="sliderarrows boxs">
            <div className="arrowtop">
              <div className="download">
                <ul>
                  <li className="actiondiv">
                    {!upload &&
                    <a href={downloadLink} className="actionlink">
                      {t('Download')} <i
                        className="fa fa-caret-down"
                        aria-hidden="true"
                      />
                    </a>}
                  </li>
                </ul>
              </div>
              <a href="#" className="closemodalbtn" onClick={e => toggleModal(e, false)}><img src="/img/closemodal.svg" alt="close" /></a>
            </div>
          </div>
          <div className="slidermain boxs">
            <div className="modalform boxs">
              <img
                src={mainScr}
                alt="img"
                className="img-responsive width img-blog"
                onError={e => onImageError(e)}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

ImageModal.propTypes = {
  t: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  mainScr: PropTypes.string.isRequired,
  onImageError: PropTypes.func.isRequired,
};

export default ImageModal;



// WEBPACK FOOTER //
// ./src/components/modalWindows/imageModal/ImageModal.jsx